<template>
    <span class="fa-stack fa-xs">
        <i class="fas fa-euro-sign fa-stack-1x" style="color:gold"></i>
        <i class="fal fa-ban fa-stack-2x" style="color:Tomato"></i>
    </span>
</template>

<script>
    export default {
        name: 'UnpaidOrderIcon',
    }
</script>

<style scoped>

</style>
